import { Logger } from '../../../../../shared/helpers/loggerFacade';
import { RoomAgentError } from '../../errors';

type RoomAgentAudioProcessorOptions = {
    audioCtx: AudioContext;
    logger: Logger;
};

export class RoomAgentAudioProcessor {
    private logger: Logger;
    private audioCtx: AudioContext;
    private mediaStream?: MediaStream;
    private sourceNode?: MediaStreamAudioSourceNode;
    private destinationNode?: MediaStreamAudioDestinationNode;
    private gainNode: GainNode;
    private compressorNode: DynamicsCompressorNode;
    private processorInputNode: AudioNode;
    private processorOutputNode: AudioNode;

    constructor({ audioCtx, logger }: RoomAgentAudioProcessorOptions) {
        this.logger = logger;
        this.audioCtx = audioCtx;

        this.gainNode = this.audioCtx.createGain();
        this.gainNode.gain.value = 2;

        this.compressorNode = this.audioCtx.createDynamicsCompressor();
        this.compressorNode.threshold.value = -45;

        // Здесь определяем порядок процессинга
        this.compressorNode.connect(this.gainNode);
        this.processorInputNode = this.compressorNode;
        this.processorOutputNode = this.gainNode;
    }

    public replaceTrack(track: MediaStreamTrack) {
        const trackChannelCount = track.getSettings()?.channelCount;

        if (typeof trackChannelCount !== 'number' || trackChannelCount > 1) {
            this.logger.warn(
                new RoomAgentError('RoomAgentAudioProcessor error', 'Unsupported channel count', {
                    method: 'replaceTrack',
                    additional: {
                        channelCount: trackChannelCount,
                    },
                })
            );
        }

        if (this.sourceNode) {
            this.sourceNode.disconnect(this.processorInputNode);
            this.sourceNode = undefined;
        }

        if (this.destinationNode) {
            this.processorOutputNode.disconnect(this.destinationNode);
            this.destinationNode = undefined;
        }

        this.mediaStream = new MediaStream([track]);
        this.sourceNode = this.audioCtx.createMediaStreamSource(this.mediaStream);
        // Пересоздаем destination, иначе goloom падает из-за одинаковых id треков
        this.destinationNode = this.audioCtx.createMediaStreamDestination();
        // Нам приходит 1 канал, а в процессе процессинга под капотом их становится 2.
        // Из-за этого падает внутренний процессинг голума.
        this.destinationNode.channelCountMode = 'explicit';
        this.destinationNode.channelCount = 1;
        this.sourceNode.connect(this.processorInputNode);
        this.processorOutputNode.connect(this.destinationNode);
    }

    public getProcessedTrack(): MediaStreamTrack {
        const track = this.destinationNode?.stream.getAudioTracks()[0];

        if (!track) {
            throw new RoomAgentError('RoomAgentAudioProcessor error', 'Empty processed audio track', {
                method: 'getProcessedTrack',
            });
        }

        return track;
    }
}
